const options = {
  5: "bg-blue-300/5",
  10: "bg-blue-300/10",
  25: "bg-blue-300/25",
  50: "bg-blue-300/50",
  75: "bg-blue-300/75",
  90: "bg-blue-300/90",
  100: "bg-blue-300",
};

const from = {
  5: "from-blue-300/5",
  10: "from-blue-300/10",
  25: "from-blue-300/25",
  50: "from-blue-300/50",
  75: "from-blue-300/75",
  90: "from-blue-300/90",
  100: "from-blue-300",
};

export default function getBackgroundBlue300(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
